import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/no-danger */ import { Tooltip } from 'antd';
import DOMPurify from 'dompurify';
import React from 'react';
export const TaskName = ({ taskName, dataCy, className, style })=>{
    return /*#__PURE__*/ _jsx(Tooltip, {
        destroyTooltipOnHide: true,
        placement: "topLeft",
        title: /*#__PURE__*/ _jsx("div", {
            dangerouslySetInnerHTML: {
                // eslint-disable-next-line import/namespace, @typescript-eslint/naming-convention
                __html: DOMPurify.sanitize(taskName)
            }
        }),
        children: /*#__PURE__*/ _jsx("div", {
            "data-cy": dataCy,
            style: style,
            className: `project-template-task ${className !== null && className !== void 0 ? className : ''}`,
            dangerouslySetInnerHTML: {
                // eslint-disable-next-line import/namespace, @typescript-eslint/naming-convention
                __html: DOMPurify.sanitize(taskName)
            }
        })
    });
};
export const PhaseName = ({ phaseName })=>{
    const content = /*#__PURE__*/ _jsx("div", {
        className: "project-template-task",
        dangerouslySetInnerHTML: {
            // eslint-disable-next-line import/namespace, @typescript-eslint/naming-convention
            __html: DOMPurify.sanitize(phaseName)
        }
    });
    return /*#__PURE__*/ _jsx(Tooltip, {
        placement: "topLeft",
        title: content,
        destroyTooltipOnHide: true,
        children: content
    });
};
